<page-content [fullPageWidth]="true">
    <header-elitment header
                     [hasSideMenu]="true"></header-elitment>
    <side-menu left-menu>
        <evaluation-athlete-side-menu side-menu
              [evaluationAthlete]="evaluationAthlete!"
              [organization]="organization"
              [athleteUser]="athleteUser"
              [evaluationsAthletes]="evaluationsAthletes"
              [selectedEvaluations$]="selectedEvaluations$"
              [selectedEvaluationsEvent$]="selectedEvaluationsEvent$">
        </evaluation-athlete-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <div class="editor">
        <div class="evaluation-athlete-show">
            <module-content *ngIf="!is401 && !is404"
                            [title]="evaluationAthlete ? evaluationAthlete['evaluation']?.title: 'Evaluations' | translate">
                <mat-card-header class="evaluation-athlete-status">
                    <mat-card-subtitle>
                        <mat-chip-set>
                            <mat-chip *ngIf="evaluationAthlete"
                                      [ngClass]="evaluationAthlete.status === 'opened' ? 'mat-chip-accent' : ''">{{ evaluationAthlete.status??'' | translate }}
                            </mat-chip>
                        </mat-chip-set>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content class="evaluation-athlete-content mb-20" *ngIf="evaluationAthlete">
                    <div class="evaluation-athlete-date mb-10">{{ 'CreatedAt' | translate }} {{ evaluationAthlete.date|appDate:'mediumDate' }}</div>
                    <div class="evaluation-athlete-descriptions">{{ evaluationAthlete['evaluation']?.description }}</div>
                </mat-card-content>

                <div class="header">
                    <evaluation-athlete-result
                        *ngIf="evaluationAthlete; else noEvaluation"
                        [evaluationAthlete]="evaluationAthlete"
                        [selectedEvaluations$]="selectedEvaluations$"
                        [selectedEvaluationsEvent$]="selectedEvaluationsEvent$"
                        [organization]="organization">
                    </evaluation-athlete-result>
                    <ng-template #noEvaluation>
                        <div class="evaluation-athlete-no-evaluation">
                            {{ 'EvaluationAthleteNoEvaluation'|translate }}
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="evaluationAthlete">
                    <p class="note-title">{{ 'Evaluation_notes' | translate }}</p>
                    <p class="note-content">{{ evaluationAthleteNotes.value }}</p>
                </div>

            </module-content>
        </div>
    </div>

    <div>
        <ng-container>
            <!-- TODO: check rights -->
            <main-action
                *ngIf="!is401 && !is404 && evaluationAthlete && evaluationAthlete.status == 'opened'"
                [title]="'Edit_Evaluation' | translate"
                [icon]="'edit'"
                [color]="'accent'"
                [link]="'/' + organization.code + '/athletes/' + athleteUser.id +'/evaluations/' + evaluationAthlete.id + '/edit'"
            >
            </main-action>
        </ng-container>
    </div>

</page-content>
